<template>
  <div class="capsule-toy-land">
    <div class="background">
      <div class="content-container">
        <!-- Header with coin count -->
        <div class="header">
          <div class="row col-12 d-flex justify-content-end">
            <!-- 合併代幣顯示，滑鼠懸停顯示詳細資訊 -->
            <div
              class="coin-container mr-3"
              @mouseenter="showTooltip = true"
              @mouseleave="showTooltip = false"
            >
              <div class="coin-icon"></div>
              <div class="coin-count">
                {{ remainingChances + virtualTokens }}
              </div>

              <!-- Tooltip popup -->
              <div v-if="showTooltip" class="coin-tooltip">
                <div class="tooltip-item">
                  <div class="tooltip-icon chance-icon">✅</div>
                  <span class="tooltip-text"
                    >學習成果：{{ remainingChances }}</span
                  >
                </div>
                <div class="tooltip-item">
                  <div class="tooltip-icon virtual-token-icon"></div>
                  <span class="tooltip-text"
                    >虛擬代幣：{{ virtualTokens }}</span
                  >
                </div>
                <div class="tooltip-divider"></div>
                <div class="tooltip-total">
                  總計：{{ remainingChances + virtualTokens }}
                </div>
              </div>
            </div>

            <div class="my-rewards" @click="openMyPrizesModal">
              <div class="rewards-icon"></div>
              <div class="rewards-text">{{ $t("wo-de-jiang-pin") }}</div>
            </div>
          </div>
        </div>

        <!-- Main content -->
        <div class="main-content" v-if="!isAnimating">
          <div class="container-fluid">
            <div class="row justify-content-between">
              <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-3 mb-lg-0">
                <img
                  class="gacha_machine"
                  :src="gacha_machineImg"
                  alt="gacha_machine"
                />
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                <div class="white-card">
                  <h1 class="title" id="gacha-text-color">
                    {{ $t("zhuan-dan-chou-jiang") }}
                  </h1>
                  <div class="description">
                    <p id="gacha-text-color">歡迎來到MSU扭蛋樂園！</p>
                    <p id="gacha-text-color">
                      你知道嗎？只要你認真看完一本繪本或一部
                      英文影片，就能獲得一個綠色勾勾
                      ✅，每個綠勾勾都會變成一枚【扭蛋幣】！
                    </p>
                    <p id="gacha-text-color">
                      在這裡，蒐集滿100枚扭蛋幣，就可以轉一次扭蛋，有機會抽中超酷的不鏽鋼保溫瓶、可愛貼紙包，還有超商禮券等好禮等你拿～
                    </p>
                    <p id="gacha-text-color">
                      MSU每月會統計一次，實體獎品會寄到你班上，請老師發給你喔！
                      快開始閱讀和觀看影片，努力集扭蛋幣，把獎品通通帶回家吧！
                    </p>
                  </div>
                  <button
                    type="button"
                    class="play-button"
                    @click="startGacha"
                    :disabled="!canDraw"
                  >
                    PLAY
                  </button>
                  <!-- 添加當實體獎品全部領取完畢時的提示 -->
                  <div v-if="!hasPhysicalPrizesAvailable" class="prize-notice">
                    <p id="gacha-text-color">
                      所有實體獎品已被領取完畢，暫時無法抽獎
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!isAnimating">
          <!-- 獎品展示區域 -->
          <div class="prize-section">
            <div class="section-title my-4">
              <div class="section-title-bg">
                <span>獎品介紹</span>
              </div>
            </div>

            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-6 col-sm-6 col-md-6 col-lg-4 mb-4"
                  v-for="prize in allPrizes"
                  :key="prize.prize_id"
                >
                  <div
                    class="prize-card"
                    :class="{ 'prize-card-empty': prize.remaining_count === 0 }"
                  >
                    <div class="prize-image">
                      <img :src="prize.image_url" :alt="prize.name" />
                      <div
                        v-if="prize.remaining_count === 0"
                        class="prize-sold-out"
                      >
                        <span>已抽完</span>
                      </div>
                    </div>
                    <div
                      class="prize-name"
                      style="color: #58320f"
                      v-html="prize.name"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer decoration - 放在content-container外面，讓它可以是全寬的 -->
      <div class="footer-decoration"></div>

      <!-- 動畫對話框 - 修改為僅覆蓋內容區域 -->
      <div v-if="isAnimating" class="animation-dialog">
        <div class="animation-content">
          <!-- 添加關閉按鈕 -->
          <div class="close-animation-btn" @click="cancelAnimation">
            <i class="fa-solid fa-xmark"></i>
          </div>
          <!-- 轉蛋動畫內容 -->
          <div id="egg" class="pet-egg-container">
            <!-- 只有當機器動畫結束後才顯示這部分 -->
            <div v-if="step >= 2 && step < 4" id="mask" class="pet-mask">
              <img
                id="rays"
                :src="sunnyRaysImg"
                :class="{ 'rays-animate': step >= 2 && step < 4 }"
              />
              <img id="ball" :src="ballImg" :class="{ hide: step > 3 }" />
              <img
                id="ball_open"
                :src="ballOpenImg"
                :class="{ show: step > 3 }"
              />
              <img
                id="flash"
                :src="flashImg"
                :class="{ 'flash-animate': step === 3 }"
              />
            </div>

            <div v-if="step >= 4" id="pet_box" class="show">
              <img id="rays1" :src="sunnyRays1Img" class="rays1-animate" />
              <img
                id="tarpet"
                :src="currentPrizeImage || catImg"
                class="tarpet"
                :class="{ 'pet-appear': step >= 4 }"
              />
            </div>

            <!-- 機器部分 -->
            <div id="machine_box" :class="{ 'machine-box-hide': step >= 2 }">
              <img id="smoke_left" :src="smokeImg" class="smoke_left" />
              <img id="smoke_right" :src="smoke2Img" class="smoke_right" />
              <div
                id="machine"
                class="machine"
                :class="{
                  'machine-clickable': step === 0 && !isControlClicking,
                }"
                @click="handleMachineClick"
              >
                <img
                  id="machine_img"
                  :src="toyMachineImg"
                  :class="{
                    'machine-img-clickable': step === 0 && !isControlClicking,
                  }"
                />
                <img
                  id="toy_control"
                  :src="toyControlImg"
                  :class="{
                    toy_control_active: step >= 1,
                    toy_control_scale: step === 0 && !isControlClicking,
                  }"
                />
              </div>
            </div>

            <!-- 結果確認對話框 - 改為使用 prize-result-container 樣式 -->
            <div v-if="step >= 5" class="prize-result-in-animation">
              <div class="prize-result-container">
                <h3 class="prize-result-title">
                  {{ $t("t-gong-xi-huo-de", [$t("gong-xi-huo-de")]) }}
                </h3>
                <div class="prize-result-image">
                  <img
                    :src="currentPrizeImage || catImg"
                    :alt="currentPrize.name"
                  />
                </div>
                <div class="prize-result-name">
                  {{ currentPrize.name }}
                </div>
                <div class="button-group">
                  <button class="confirm-button" @click="finishAnimation">
                    {{ $t("que-ding") }}
                  </button>
                  <button
                    class="play-again-button"
                    @click="playAgain"
                    :disabled="!canPlayAgain"
                  >
                    再轉一次
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加MyGachaPrizeModal組件 -->
    <MyGachaPrizeModal :content-list="studentPrizes" ref="myPrizesModalRef" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { ApiPrize, ApiStudentProgress } from "@/service/apis/prize";
import { useI18n } from "vue-i18n";
import { useUserInfoStore } from "@/store/modules/userInfo";
import MyGachaPrizeModal from "@/components/Modal/MyGachaPrizeModal.vue";
// 如果主專案中沒有引入Bootstrap CSS，可以在這裡引入
// import "bootstrap/dist/css/bootstrap.min.css"; // 取消註釋以直接在組件中引入

const { locale, t } = useI18n({
  inheritLocale: true,
});

// 從用戶store中獲取當前登入用戶信息
const userStore = useUserInfoStore();
const studentId = computed(() => userStore.student.stuID);

const isAnimating = ref(false);
const remainingChances = ref(0); // 改為 0，等待 API 回傳實際次數
const canDraw = ref(false); // 預設為 false，等待 API 確認
const currentPrize = ref({ name: t("ce-shi-chong-wu-1") });
const currentPrizeImage = ref("");
const prizeHistory = ref([]);
const step = ref(0);
const allPrizes = ref([]); // 所有可用獎品列表
const studentPrizes = ref([]); // 學生已獲得的獎品列表
const virtualTokens = ref(0);
const showTooltip = ref(false);
const isControlClicking = ref(false);

// API域名
const apiDomain = "https://app.mangosteems.com/apitchr";

// 獲取獎品圖片完整URL的方法
const getPrizeImageUrl = (imagePath) => {
  if (!imagePath) return "";

  // 從完整路徑中提取檔案名稱
  const filename = imagePath.split("/").pop();
  if (!filename) return "";

  return `${apiDomain}/prize/image/${filename}`;
};

// 使用 Vite 的方式載入圖片
const sunnyRaysImg = computed(() => {
  return new URL(`../petroom_loacal/images/egg/sunny_rays.png`, import.meta.url)
    .href;
});

const ballImg = computed(() => {
  return new URL(`../petroom_loacal/images/egg/ball.png`, import.meta.url).href;
});

const ballOpenImg = computed(() => {
  return new URL(`../petroom_loacal/images/egg/ball_open.png`, import.meta.url)
    .href;
});

const flashImg = computed(() => {
  return new URL(`../petroom_loacal/images/egg/flash.png`, import.meta.url)
    .href;
});

const sunnyRays1Img = computed(() => {
  return new URL(
    `../petroom_loacal/images/egg/sunny_rays1.png`,
    import.meta.url
  ).href;
});

const catImg = computed(() => {
  return new URL(`../petroom_loacal/images/egg/Cat001.png`, import.meta.url)
    .href;
});

const smokeImg = computed(() => {
  return new URL(`../petroom_loacal/images/egg/smoke.png`, import.meta.url)
    .href;
});

const smoke2Img = computed(() => {
  return new URL(`../petroom_loacal/images/egg/smoke2.png`, import.meta.url)
    .href;
});

const toyMachineImg = computed(() => {
  return new URL(
    `../petroom_loacal/images/egg/toy_machine1.png`,
    import.meta.url
  ).href;
});

const toyControlImg = computed(() => {
  return new URL(
    `../petroom_loacal/images/egg/toy_control.png`,
    import.meta.url
  ).href;
});
const msu_tokenImg = computed(() => {
  return new URL(`../assets/img/icon/msu_token.png`, import.meta.url).href;
});

const boardImg = computed(() => {
  return new URL(`../petroom_loacal/images/gacha/board.png`, import.meta.url)
    .href;
});
const MSUpirateImg = computed(() => {
  return new URL(
    `../petroom_loacal/images/gacha/MSUpirate.png`,
    import.meta.url
  ).href;
});
const gacha_machineImg = computed(() => {
  return new URL(
    `../petroom_loacal/images/gacha/gachamachine.png`,
    import.meta.url
  ).href;
});
// 處理控制桿點擊
const handleControlClick = async () => {
  if (step.value > 0 || isControlClicking.value) return; // 防止重複點擊

  isControlClicking.value = true;

  try {
    // 檢查總資源是否足夠（100點）
    const totalAvailableResources =
      remainingChances.value + virtualTokens.value;
    const requiredTotal =
      studentId.value === "STU-LzCBSvXvzuPfBSVpHnULbk" ? 1 : 100;

    if (totalAvailableResources < requiredTotal) {
      alert(
        `抽獎失敗：資源不足。\n需要總計 ${requiredTotal} 點數。\n當前擁有 ${remainingChances.value} 個機會和 ${virtualTokens.value} 個虛擬代幣。\n總計可用：${totalAvailableResources}`
      );
      isControlClicking.value = false;
      return;
    }

    console.log(
      `開始合併抽獎，當前總資源：${totalAvailableResources}（機會：${remainingChances.value}，代幣：${virtualTokens.value}）`
    );

    // 調用新的自動化合併抽獎API（不需要傳入payload）
    const result = await ApiPrize.combinedDraw();

    console.log("合併抽獎結果", result);

    if (result.status === "success") {
      const record = result.record;

      // 更新獎品資訊 - 修正資料結構路徑
      if (record.draw_result && record.draw_result.prize_details) {
        currentPrize.value = record.draw_result.prize_details;
        currentPrizeImage.value = getPrizeImageUrl(
          record.draw_result.prize_details.image_url
        );
      }

      // 更新剩餘資源（優先使用 draw_result 中的 remaining_resources）
      if (record.draw_result && record.draw_result.remaining_resources) {
        remainingChances.value =
          record.draw_result.remaining_resources.chances || 0;
        virtualTokens.value =
          record.draw_result.remaining_resources.tokens || 0;
      } else if (record.updated_status) {
        remainingChances.value = record.updated_status.remaining_chances || 0;
        virtualTokens.value = record.updated_status.virtual_tokens || 0;
      } else if (record.after_draw) {
        // 使用 after_draw 資訊更新
        remainingChances.value = record.after_draw.chances || 0;
        virtualTokens.value = record.after_draw.tokens || 0;
      }

      // 記錄資源使用情況
      if (record.resource_usage) {
        console.log(
          `資源使用詳情：使用代幣 ${record.resource_usage.tokens_used}，使用機會 ${record.resource_usage.chances_used}，共消耗 ${record.resource_usage.total_consumed}`
        );
      }

      console.log(
        `抽獎後剩餘：機會 ${remainingChances.value}，虛擬代幣 ${virtualTokens.value}`
      );
      console.log("當前獎品資訊:", currentPrize.value);
      console.log("當前獎品圖片URL:", currentPrizeImage.value);

      // 重新獲取所有獎品並更新狀態
      fetchAllPrizes();

      // 開始動畫序列
      startGachaAnimation();
    } else {
      throw new Error("抽獎失敗: " + (result.record || "未知錯誤"));
    }
  } catch (error) {
    console.error("獲取獎品失敗:", error);
    // 顯示更友好的錯誤訊息
    const errorMessage =
      error.response?.data?.record || error.message || "未知錯誤";
    alert("獲取獎品失敗: " + errorMessage);
    isControlClicking.value = false;
    return;
  }
};

// 開始轉蛋動畫序列
const startGachaAnimation = () => {
  // 啟動控制桿動畫
  step.value = 1;
  playSound("control");

  // 延遲後，隱藏機器部分，顯示下一階段動畫
  setTimeout(() => {
    step.value = 2; // 隱藏機器，顯示光芒和球
    playSound("pet1");

    setTimeout(() => {
      step.value = 3; // 顯示閃光效果

      setTimeout(() => {
        step.value = 4; // 顯示寵物
        playSound("pet3");

        setTimeout(() => {
          step.value = 5; // 顯示確認對話框
          playSound("pet2");
          // 動畫完成，重置點擊狀態
          isControlClicking.value = false;
        }, 2000);
      }, 1500);
    }, 1500);
  }, 1000);
};

// 處理機器點擊（整合抽獎和動畫）
const handleMachineClick = async () => {
  if (step.value > 0 || isControlClicking.value) return; // 防止重複點擊

  // 直接調用抽獎邏輯
  await handleControlClick();
};

// 完成動畫
const finishAnimation = () => {
  isAnimating.value = false;

  // 重新載入獎品歷史和學生獎品列表
  checkDrawEligibility();
  fetchStudentPrizes(); // 重新獲取學生獎品列表

  // 重置動畫狀態，準備下次使用
  setTimeout(() => {
    step.value = 0;
  }, 500);
};

// 再轉一次功能
const playAgain = async () => {
  // 重置動畫狀態
  step.value = 0;
  isControlClicking.value = false;

  // 檢查是否還能繼續抽獎
  const requiredTotal =
    studentId.value === "STU-LzCBSvXvzuPfBSVpHnULbk" ? 1 : 100;
  const totalAvailableResources = remainingChances.value + virtualTokens.value;

  if (totalAvailableResources < requiredTotal) {
    alert(
      `資源不足，無法再次抽獎。\n需要總計 ${requiredTotal} 點數。\n當前擁有 ${remainingChances.value} 個機會和 ${virtualTokens.value} 個虛擬代幣。`
    );
    finishAnimation(); // 返回主頁面
    return;
  }

  if (!hasPhysicalPrizesAvailable.value) {
    alert("所有實體獎品已被領取完畢，無法再次抽獎。");
    finishAnimation(); // 返回主頁面
    return;
  }

  // 播放開始音效
  playSound("fall");

  // 延遲一下再開始新的抽獎，讓用戶感受到轉場
  setTimeout(() => {
    handleControlClick();
  }, 500);
};

// 計算是否可以再轉一次
const canPlayAgain = computed(() => {
  const requiredTotal =
    studentId.value === "STU-LzCBSvXvzuPfBSVpHnULbk" ? 1 : 100;
  const totalAvailableResources = remainingChances.value + virtualTokens.value;
  return (
    totalAvailableResources >= requiredTotal && hasPhysicalPrizesAvailable.value
  );
});

// 取消動畫並返回主頁
const cancelAnimation = () => {
  // 重置動畫狀態
  isAnimating.value = false;
  step.value = 0;

  // 如果在抽獎過程中取消，返還扭蛋幣
  if (step.value >= 1) {
    remainingChances.value++;
  }
};

// 播放音效
const playSound = (soundName) => {
  const soundPaths = {
    fall: new URL(`../petroom_loacal/os/fall.mp3`, import.meta.url).href,
    control: new URL(`../petroom_loacal/os/roll.mp3`, import.meta.url).href,
    pet1: new URL(`../petroom_loacal/os/get pet.mp3`, import.meta.url).href,
    pet2: new URL(`../petroom_loacal/os/get pet2.mp3`, import.meta.url).href,
    pet3: new URL(`../petroom_loacal/os/get pet3.mp3`, import.meta.url).href,
  };

  try {
    if (soundPaths[soundName]) {
      const audio = new Audio(soundPaths[soundName]);
      audio.play().catch((err) => {
        console.log("音效播放失敗:", err);
      });
    }
  } catch (e) {
    console.error("播放音效時發生錯誤:", e);
  }
};

// 在script部分添加新的計算屬性和方法
const hasPhysicalPrizesAvailable = computed(() => {
  // 過濾出實體獎品
  const physicalPrizes = allPrizes.value.filter(
    (prize) => prize.type === "physical"
  );

  // 檢查是否還有實體獎品剩餘
  return physicalPrizes.some(
    (prize) => prize.remaining_count !== null && prize.remaining_count > 0
  );
});

// 修改canDraw的計算，考慮實體獎品是否已經領完以及資源是否足夠
const updateCanDraw = () => {
  const requiredTotal =
    studentId.value === "STU-LzCBSvXvzuPfBSVpHnULbk" ? 1 : 100;

  // 檢查是否有足夠的資源（機會 + 虛擬代幣的總和）
  const totalAvailableResources = remainingChances.value + virtualTokens.value;
  const hasEnoughResources = totalAvailableResources >= requiredTotal;

  // 玩家需要有足夠的資源且還有實體獎品可以抽
  canDraw.value = hasEnoughResources && hasPhysicalPrizesAvailable.value;

  // 如果沒有實體獎品可抽，在console中記錄
  if (!hasPhysicalPrizesAvailable.value) {
    console.log("所有實體獎品已被領取完畢");
  }

  // 如果資源不足，在console中記錄
  if (!hasEnoughResources) {
    console.log(
      `資源不足: 需要總計 ${requiredTotal} 點數，當前擁有 ${remainingChances.value} 個機會和 ${virtualTokens.value} 個虛擬代幣，總計可用 ${totalAvailableResources}`
    );
  }
};

// 修改checkDrawEligibility方法，加入對虛擬代幣的檢查
const checkDrawEligibility = async () => {
  try {
    let response;

    // 根據 VITE_MSU_DOMAIN 決定是否設定開始日期
    if (import.meta.env.VITE_MSU_DOMAIN === "app") {
      // 不限開始時間
      response = await ApiPrize.getStudentProgressAndPrizes(studentId.value);
    } else {
      // 設定開始時間為 2025-06-01
      response = await ApiPrize.getStudentProgressAndPrizes(
        studentId.value,
        "2025-06-01"
      );
    }

    console.log("prizesResponse", response);

    if (response.status === "success") {
      console.log(
        "response.record chance = = =",
        response.record.remaining_chances
      );
      remainingChances.value = response.record.remaining_chances;

      // 存儲虛擬代幣數量
      virtualTokens.value = response.record.virtual_tokens || 0;

      // 更新獎品歷史記錄
      if (response.records) {
        prizeHistory.value = response.records.map((prize) => ({
          record_id: prize.id,
          name: prize.name,
          image_url: getPrizeImageUrl(prize.image_url),
          obtained_at: prize.created_at,
        }));
      }

      // 獲取所有獎品後更新canDraw
      fetchAllPrizes().then(() => {
        updateCanDraw();
      });
    }
  } catch (error) {
    console.error("檢查抽獎資格失敗:", error);
    remainingChances.value = 0;
    virtualTokens.value = 0;
    canDraw.value = false;
  }
};

// 修改fetchAllPrizes，在獲取獎品後更新canDraw狀態
const fetchAllPrizes = async () => {
  try {
    const response = await ApiPrize.getAll();
    console.log("response", response);
    if (response.status === "success" && response.record) {
      // 處理圖片URL
      allPrizes.value = response.record.map((prize) => ({
        ...prize,
        image_url: getPrizeImageUrl(prize.image_url),
      }));
      console.log("All prizes:", allPrizes.value);

      // 更新抽獎資格狀態
      updateCanDraw();
    }
  } catch (error) {
    console.error("獲取所有獎品失敗:", error);
  }
};

// 修改startGacha，添加資源檢查
const startGacha = async () => {
  if (!canDraw.value) return;

  const requiredTotal =
    studentId.value === "STU-LzCBSvXvzuPfBSVpHnULbk" ? 1 : 100;

  // 檢查是否有足夠的資源（合併總計）
  const totalAvailableResources = remainingChances.value + virtualTokens.value;
  const hasEnoughResources = totalAvailableResources >= requiredTotal;

  // 再次檢查是否有實體獎品和足夠的資源
  if (!hasPhysicalPrizesAvailable.value) {
    alert("很抱歉，所有實體獎品已被領取完畢，暫時無法抽獎。");
    canDraw.value = false;
    return;
  }

  if (!hasEnoughResources) {
    alert(
      `抽獎失敗：資源不足。\n需要總計 ${requiredTotal} 點數。\n當前擁有 ${remainingChances.value} 個機會和 ${virtualTokens.value} 個虛擬代幣。\n總計可用：${totalAvailableResources}`
    );
    canDraw.value = false;
    return;
  }

  isAnimating.value = true;
  step.value = 0;

  // 播放開始的效果音
  playSound("fall");
};

// 添加Modal引用
const myPrizesModalRef = ref(null);

// 開啟我的獎品Modal的函數
const openMyPrizesModal = () => {
  // 重新獲取學生獎品，確保數據是最新的
  fetchStudentPrizes().then(() => {
    // 使用jQuery打開Modal (因為Modal是用Bootstrap實現的)
    $("#my-gacha-prize-modal").modal("show");
  });
};

// 修改獲取學生獎品的函數，確保返回Promise以便鏈式調用
const fetchStudentPrizes = async () => {
  try {
    const response = await ApiPrize.getStudentPrizes(studentId.value);
    console.log("fetchStudentPrizes response", response);
    if (response.status === "success" && response.record) {
      // 修正：處理新的API結構 prize_records
      if (
        response.record.prize_records &&
        Array.isArray(response.record.prize_records)
      ) {
        studentPrizes.value = response.record.prize_records.map((prize) => ({
          ...prize,
          image_url: getPrizeImageUrl(prize.image_url),
          obtained_at: prize.obtained_at || prize.created_at, // 確保即使沒有obtained_at也能使用created_at作為後備
        }));
        console.log("Student prizes:", studentPrizes.value);
      } else {
        console.log("沒有找到獎品記錄或格式不正確");
        studentPrizes.value = [];
      }
    }
    return Promise.resolve();
  } catch (error) {
    console.error("獲取學生獎品失敗:", error);
    return Promise.reject(error);
  }
};

// 格式化日期

onMounted(() => {
  checkDrawEligibility();
  fetchAllPrizes();
  fetchStudentPrizes();
});
</script>

<style scoped>
.capsule-toy-land {
  width: 100%;
  min-height: 100vh;
  font-family: "Poppins", sans-serif;
  color: #583110;
  position: relative;
}

.background {
  /* background-color: #d7b19b; */
  background-color: #ffecdc;
  background-image: url("../petroom_loacal/images/gacha/background.jpg");
  background-size: 100% 100%;
  background-position: center;
  min-height: 100vh;
  padding: 0px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 0;
}

.content-container {
  max-width: 1200px;
  width: 100%;
  margin: 60px auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

/* Header styling */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 15px 5px;
}

.coin-container {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.coin-icon {
  width: 36px;
  height: 36px;
  background-image: url("../assets/img/icon/msu_token.png");
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 10px;
}

.coin-count {
  font-family: "ADLaM Display", sans-serif;
  font-size: 20px;
  color: #583110;
  font-weight: 600;
}

/* Tooltip 樣式 */
.coin-tooltip {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 2px solid #ffc067;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 180px;
  margin-top: 5px;
  animation: tooltip-fade-in 0.2s ease-out;
}

.coin-tooltip::before {
  content: "";
  position: absolute;
  top: -8px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #ffc067;
}

.coin-tooltip::after {
  content: "";
  position: absolute;
  top: -6px;
  right: 21px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid white;
}

.tooltip-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  min-height: 24px; /* 確保每個項目有固定高度 */
}

.tooltip-item:last-child {
  margin-bottom: 0;
}

.tooltip-icon {
  width: 24px;
  height: 24px;
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chance-icon {
  background-image: none;
  font-size: 16px;
  color: #4caf50;
  font-weight: bold;
  line-height: 1;
}

.tooltip-text {
  font-size: 14px;
  color: #583110;
  font-weight: 500;
  line-height: 1.2;
  flex: 1;
}

.virtual-token-icon {
  width: 24px;
  height: 24px;
  background-image: url("../petroom_loacal/images/purse2.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.tooltip-divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 8px 0;
}

.tooltip-total {
  font-size: 14px;
  color: #583110;
  font-weight: 700;
  text-align: center;
  padding: 4px 0;
  background-color: #fff8e6;
  border-radius: 6px;
}

@keyframes tooltip-fade-in {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.virtual-token-container {
  display: flex;
  align-items: center;
}

.my-rewards {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.rewards-icon {
  width: 36px;
  height: 36px;
  background-image: url("../petroom_loacal/images/gacha/treasure.png");
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 10px;
}

.rewards-text {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.8px;
  color: #583110;
}

/* Main content styling */
.main-content {
  width: 100%;
  margin-top: 5px;
  padding: 0;
}

.main-content .container-fluid {
  padding: 0 15px;
}

.main-content .row {
  width: 100%;
  margin: 0;
}

.white-card {
  background-color: white;
  border-radius: 16px;
  padding: 36px 36px 52px 36px;
  width: 100%;
  max-width: 785px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: visible;
  margin-bottom: 15px;
}

/* 使用::before作為左下角裝飾圖 */
.white-card::before {
  content: "";
  position: absolute;
  bottom: -60px;
  left: -45px;
  width: 120px;
  height: 200px;
  background-image: url("../petroom_loacal/images/gacha/board.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 2;
}

/* 使用::after作為右下角裝飾圖 */
.white-card::after {
  content: "";
  position: absolute;
  bottom: -40px;
  right: -80px;
  width: 280px; /* 縮小寬度以適應RWD */
  height: 180px;
  background-image: url("../petroom_loacal/images/gacha/MSUpirate.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 2;
}

.title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 15px;
}

.description {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 20px;
}

.description p {
  margin-bottom: 10px;
}

.description p:first-child {
  font-weight: 700;
}

/* 添加更高優先級的選擇器，使其能覆蓋其他樣式 */
#gacha-text-color,
.white-card .description p#gacha-text-color,
.white-card h1#gacha-text-color,
div.description p#gacha-text-color {
  color: #58320f !important;
}

/* 確保按鈕文字顏色不受影響 */
.play-button {
  background-color: #7a4210;
  color: #f5f5f5 !important;
  font-size: 20px;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  padding: 8px 30px;
  cursor: pointer;
  transition: background-color 0.3s;
  display: block;
  margin: 0 auto 15px;
  min-width: 200px;
}

.play-button:hover:not(:disabled) {
  background-color: #915109;
}

.play-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* Prize section styling */
.prize-section {
  margin-top: 10px;
}

.section-title {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.section-title-bg {
  background-image: url("../petroom_loacal/images/gacha/deco.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  padding: 15px 40px;
  text-align: center;
  width: 400px;
}

.section-title-bg span {
  color: #f5f5f5;
  font-size: 20px;
  font-weight: 700;
  display: inline-block;
  margin-bottom: 10px;
}

.container-fluid {
  padding: 0 15px;
  margin-top: -5px;
}

.row {
  margin: 0 -15px;
}

.col-6,
.col-sm-6,
.col-md-4,
.col-lg-3 {
  padding: 0 15px;
}

.prize-card {
  width: 100%;
  background-color: white;
  border-radius: 16px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  margin: 5px;
}

.prize-image {
  height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}

.prize-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.prize-name {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 5px;
}

.prize-date {
  font-size: 14px;
  color: #888;
  text-align: center;
}

/* Footer decoration */
.footer-decoration {
  height: 180px;
  width: 100%;
  margin-top: 0px;
  background-image: url("../petroom_loacal/images/gacha/FOOTER.png");
  background-size: contain;
  background-repeat: repeat-x;
  background-position: bottom;
  position: relative;
  z-index: 1;
}

/* Prize result styling */
.prize-result {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.prize-result-container {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  text-align: center;
  min-width: 360px;
  max-width: 90%;
  border: 4px solid #ffc067;
}

.prize-result-title {
  font-size: 22px;
  font-weight: 700;
  color: #583110;
  margin-bottom: 20px;
}

.prize-result-image img {
  height: 290px;
  object-fit: contain;
  margin: 15px 0;
}

.prize-result-name {
  font-size: 18px;
  font-weight: 600;
  color: #583110;
  margin-bottom: 20px;
}

.button-group {
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.play-again-button {
  background-color: #28a745;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
}

.play-again-button:hover:not(:disabled) {
  background-color: #218838;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}

.play-again-button:disabled {
  background-color: #6c757d;
  color: #ffffff;
  cursor: not-allowed;
  opacity: 0.6;
}

.confirm-button {
  background-color: #7a4210;
  color: #f5f5f5;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
}

.confirm-button:hover {
  background-color: #915109;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(122, 66, 16, 0.3);
}

/* 修改動畫對話框樣式，使其更好地融入頁面 */
.animation-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7); /* 更深的半透明背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* 添加透視效果，使背景模糊但仍然可見 */
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.animation-content {
  position: relative;
  width: 90%;
  max-width: 800px;
  height: 70vh;
  max-height: 700px;
  background-color: rgba(255, 236, 220, 0.9); /* 與頁面背景相似的顏色 */
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 0 30px rgba(89, 50, 16, 0.4);
  border: 4px solid #ffc067; /* 添加金色邊框 */
}

.pet-egg-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.pet-mask {
  position: relative;
  width: 100%;
  height: 100%;
  opacity: 0;
  background-color: white;
  animation: mask-out 1.2s linear forwards;
}

#rays {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200%;
  height: 200%;
  max-width: 1800px;
  max-height: 1800px;
  opacity: 0;
}

.rays-animate {
  opacity: 1 !important;
  animation: rotate 10s linear infinite;
}

#ball {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 150px;
  height: 150px;
  animation: shake 2.2s forwards;
}

#ball_open {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  opacity: 0;
}

#flash {
  position: absolute;
  top: 40%;
  left: 40%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 300px;
  opacity: 0;
}

.flash-animate {
  opacity: 1 !important;
  animation: flash 0.8s ease-out;
}

#pet_box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 1s ease;
}

#rays1 {
  position: absolute;
  width: 200%;
  height: 200%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rays1-animate {
  animation: rotate 15s linear infinite;
}

.tarpet {
  position: relative;
  width: 180px;
  height: 180px;
  object-fit: contain;
  z-index: 2;
  opacity: 0;
  transform: scale(0.2);
  transition: all 1s ease;
}

.pet-appear {
  opacity: 1 !important;
  transform: scale(1) !important;
}

#machine_box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.machine-box-hide {
  animation: box-hide 0.5s forwards;
}

#machine {
  position: relative;
  width: 50%;
  max-width: 300px;
  animation: fall 1s ease-in forwards;
}

#machine_img {
  width: 100%;
  display: block;
  cursor: pointer;
}

#toy_control {
  position: absolute;
  width: 24%;
  transform-origin: 50% 50%;
  left: 38%;
  top: 64%;
  transform: rotate(0deg);
  cursor: pointer;
}

.toy_control_scale {
  animation: bigSmall 0.5s infinite alternate;
}

.toy_control_active {
  animation: roll 0.5s ease-in forwards;
}

#smoke_left {
  position: absolute;
  width: 35%;
  left: 3%;
  top: 60%;
  transform: scale(0);
  transform-origin: 100% 100%;
  animation: smoke-out 1.2s ease-in;
}

#smoke_right {
  position: absolute;
  width: 35%;
  right: 3%;
  top: 60%;
  transform: scale(0);
  transform-origin: 0 100%;
  animation: smoke-out 1.2s ease-in;
}

/* 調整確認對話框樣式，使其更加美觀 */
#buyConfirm3 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 300px;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(89, 50, 16, 0.3);
  padding: 25px 15px;
  text-align: center;
  z-index: 1010;
}

#buyConfirm3 p {
  width: 100%;
  font-size: 1.2rem;
  font-family: Inter, sans-serif;
  font-weight: 400;
  line-height: 1;
  text-align: center;
  color: #626365;
  margin: 5px 0;
}

.confirm-button-container {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  width: 100%;
}

#buyConfirm3_ok {
  width: 120px;
  height: 36px;
  font-size: 1.2rem;
  background-color: #ffc067;
  border-radius: 18px;
  text-align: center;
  line-height: 36px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

#buyConfirm3_ok:hover {
  transform: scale(1.05);
  background-color: #ffad42;
}

.hide {
  opacity: 0 !important;
}

.show {
  opacity: 1 !important;
}
.gacha_machine {
  width: 380px;
}
/* Keep original animations */
@keyframes rotate {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes flash {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.5);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.2);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.5);
  }
}

@keyframes mask-out {
  45% {
    opacity: 0;
  }
  50% {
    opacity: 1;
    background-color: white;
  }
  60% {
    opacity: 1;
    background-color: transparent;
  }
  100% {
    background-color: transparent;
    opacity: 1;
  }
}

@keyframes box-hide {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes bigSmall {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}

@keyframes roll {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes fall {
  0% {
    transform: translateY(-200%);
  }
  60% {
    transform: translateY(0) scaleY(0.8);
  }
  70% {
    transform: translateY(0) scaleY(0.8);
  }
  90% {
    transform: translateY(0) scaleY(1);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes smoke-out {
  0% {
    transform: scale(0);
  }
  34% {
    transform: scale(0);
    opacity: 0;
  }
  57% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

@keyframes shake {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1) translate(-6px, -8px)
      rotate(-10deg);
  }
  30% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1) translate(-6px, -8px)
      rotate(-10deg);
  }
  40% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.8) translate(-6px, -8px)
      rotate(-10deg);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1) translate(-6px, -8px)
      rotate(-10deg);
  }
  55% {
    transform: translate(-50%, -50%) translate(-10px, 6px) rotate(0deg);
  }
  60% {
    transform: translate(-50%, -50%) translate(10px, 6px) rotate(-10deg);
  }
  65% {
    transform: translate(-50%, -50%) translate(-6px, -6px) rotate(10deg);
  }
  70% {
    transform: translate(-50%, -50%) translate(-6px, -8px) rotate(-10deg);
  }
  75% {
    transform: translate(-50%, -50%) translate(-10px, 0px) rotate(10deg);
  }
  80% {
    transform: translate(-50%, -50%) translate(10px, 8px) rotate(0deg);
  }
  85% {
    transform: translate(-50%, -50%) translate(6px, -6px) rotate(10deg);
  }
  90% {
    transform: translate(-50%, -50%) translate(-6px, 8px) rotate(-10deg);
  }
  95% {
    transform: translate(-50%, -50%) translate(6px, 8px) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) translate(6px, -8px) rotate(-10deg);
    opacity: 0;
  }
}

/* Responsive adjustments */
@media (max-width: 1240px) {
  .content-container {
    max-width: 100%;
  }

  /* 調整右側裝飾圖大小 */
  .white-card::after {
    width: 220px;
    right: -60px;
  }
}

@media (max-width: 992px) {
  .content-container {
    margin-top: 100px;
  }
  .gacha_machine {
    width: 280px;
  }
  /* 進一步調整裝飾圖位置和大小 */
  .white-card::before {
    width: 100px;
    height: 160px;
    bottom: -50px;
    left: -30px;
  }

  .white-card::after {
    width: 160px;
    height: 140px;
    right: -40px;
  }
}

@media (max-width: 768px) {
  .prize-card {
    padding: 15px;
    margin: 5px;
  }

  .prize-image {
    width: 100%;
    height: 200px;
  }

  /* 小螢幕時調整裝飾圖 */
  .white-card::before {
    width: 80px;
    height: 130px;
    bottom: -40px;
    left: -20px;
  }

  .white-card::after {
    width: 120px;
    height: 100px;
    right: -30px;
    bottom: -30px;
  }

  /* Tooltip 在小螢幕的調整 */
  .coin-tooltip {
    right: -10px;
    min-width: 160px;
  }

  .tooltip-text {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .prize-card {
    width: 100%;
  }

  .white-card {
    padding: 20px;
  }

  .description {
    font-size: 14px;
  }

  .content-container {
    padding: 0 10px;
  }

  /* 最小螢幕時進一步縮小裝飾圖 */
  .white-card::before {
    width: 60px;
    height: 100px;
    bottom: -35px;
    left: -15px;
  }

  .white-card::after {
    width: 90px;
    height: 80px;
    right: -20px;
    bottom: -25px;
  }

  /* 更小螢幕的 Tooltip 調整 */
  .coin-tooltip {
    right: -20px;
    min-width: 140px;
    padding: 10px;
  }

  .tooltip-icon {
    width: 20px;
    height: 20px;
  }

  .tooltip-text {
    font-size: 12px;
  }

  .tooltip-total {
    font-size: 13px;
  }

  .prize-result-in-animation .button-group {
    flex-direction: column;
    gap: 10px;
  }

  .prize-result-in-animation .play-again-button,
  .prize-result-in-animation .confirm-button {
    width: 100%;
    min-width: auto;
  }
}

/* 提示訊息樣式 */
.prize-notice {
  margin-top: 15px;
  padding: 10px;
  background-color: #fff8e6;
  border: 1px solid #ffcb8c;
  border-radius: 8px;
  text-align: center;
}

.prize-notice p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #e67e22 !important;
}

/* 獎品已領完樣式 */
.prize-card-empty {
  position: relative;
  opacity: 0.85;
}

.prize-card-empty .prize-image {
  position: relative;
}

.prize-sold-out {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.prize-sold-out span {
  background-color: rgba(255, 255, 255, 0.8);
  color: #e74c3c;
  padding: 5px 12px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 5px;
  transform: rotate(-10deg);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border: 1px solid #e74c3c;
}

/* 添加以下樣式，使背景元素在動畫時保持可見 */
.capsule-toy-land {
  position: relative; /* 確保相對定位 */
}

.background {
  position: relative; /* 確保背景相對定位 */
  z-index: 0; /* 設置較低的z-index */
}

.footer-decoration {
  position: relative;
  z-index: 1; /* 確保頁腳裝飾在動畫下層但在背景上層 */
}

/* 確保動畫對話框和結果對話框在最上層 */
.animation-dialog,
.prize-result {
  z-index: 1100; /* 高於其他元素 */
}

/* 修正動畫元素的樣式 */
#pet_box.show {
  opacity: 1 !important;
}

#ball,
#ball_open {
  width: 120px !important;
  height: 120px !important;
}

/* 修復fall動畫 */
@keyframes fall {
  0% {
    transform: translateY(-200%);
  }
  60% {
    transform: translateY(0) scaleY(0.8);
  }
  70% {
    transform: translateY(0) scaleY(0.8);
  }
  90% {
    transform: translateY(0) scaleY(1);
  }
  100% {
    transform: translateY(0);
  }
}

/* 確保動畫對話框在模糊效果的同時保持頁面其他元素可見 */
.background::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-image: inherit;
  background-size: inherit;
  background-position: inherit;
  opacity: 0.6;
}

/* 關閉動畫按鈕樣式 */
.close-animation-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 36px;
  height: 36px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1020;
  font-size: 20px;
  color: #7a4210;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.close-animation-btn:hover {
  background-color: white;
  transform: scale(1.1);
  color: #ff5c5c;
}

/* 在動畫中顯示的獎品結果樣式 */
.prize-result-in-animation {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1010;
  width: 90%;
  max-width: 400px;
}

.prize-result-in-animation .prize-result-container {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  text-align: center;
  border: 4px solid #ffc067;
  width: 100%;
}

.prize-result-in-animation .prize-result-title {
  font-size: 22px;
  font-weight: 700;
  color: #583110;
  margin-bottom: 20px;
}

.prize-result-in-animation .prize-result-image img {
  height: 200px;
  object-fit: contain;
  margin: 15px 0;
}

.prize-result-in-animation .prize-result-name {
  font-size: 18px;
  font-weight: 600;
  color: #583110;
  margin-bottom: 20px;
}

.prize-result-in-animation .button-group {
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.prize-result-in-animation .play-again-button {
  background-color: #28a745;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
}

.prize-result-in-animation .play-again-button:hover:not(:disabled) {
  background-color: #218838;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}

.prize-result-in-animation .play-again-button:disabled {
  background-color: #6c757d;
  color: #ffffff;
  cursor: not-allowed;
  opacity: 0.6;
}

.prize-result-in-animation .confirm-button {
  background-color: #7a4210;
  color: #f5f5f5;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
}

.prize-result-in-animation .confirm-button:hover {
  background-color: #915109;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(122, 66, 16, 0.3);
}

/* 響應式設計：小螢幕時按鈕垂直排列 */
@media (max-width: 480px) {
  .prize-result-in-animation .button-group {
    flex-direction: column;
    gap: 10px;
  }

  .prize-result-in-animation .play-again-button,
  .prize-result-in-animation .confirm-button {
    width: 100%;
    min-width: auto;
  }
}
</style>
